import { Link } from 'react-router-dom';
import { NavBar } from '../../components/NavBar';
import { SharedFooter } from '../../components/SharedFooter';
import { ReferencePackLicenseContent } from './ReferencePackLicenseContent';

export function ReferencePackLicensesPage() {
  return (
    <div className="min-h-screen bg-bg pt-[88px]">
      <NavBar variant="light" />
      <main className="page-container py-12">
        <Link to="/terms" className="text-sm text-text-dim border-b border-line pb-px hover:text-text hover:border-text">
          View full terms
        </Link>
        <div className="mt-8 mb-10">
          <div className="page-eyebrow">Reference packs</div>
          <h1 className="page-heading">Reference pack licenses</h1>
          <p className="mt-4 max-w-3xl text-[17px] leading-8 text-text-dim">
            Licenses for artists, hosts, teachers, and models using LifeDrawing.live reference packs.
          </p>
        </div>
        <ReferencePackLicenseContent />
      </main>
      <SharedFooter />
    </div>
  );
}
